import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MatTableDataSource } from '@angular/material';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../../../../../src/app/app.service';
import { DomainService, IMemberListItem, MemberListObject } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { user } from 'projects/icemedx-lib/src/models/common/user';
import { LoginService } from 'projects/icemedx-lib/src/login/login.service';

enum MembersActionTypes {
  Send = 1,
}

@Component({
  selector: 'members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss'],
  providers: [AppService]
})
export class MembersComponent implements OnInit {
  // data members
  dataForMembers: MatTableDataSource<IMemberListItem> = new MatTableDataSource<IMemberListItem>([]);

  // member settings
  memberListSettings: IcepanelcontainerSettings = null;
  btnInviteMemberSettings: IcecontrolSettings = new IcecontrolSettings("InviteMemberButton", { text: "Invite", class: [], glyphClass: "fa-plus-circle" }, null, null);
  btnNewMessageSettings: IcecontrolSettings = new IcecontrolSettings("icebutton", { text: "New Message", class: [], glyphClass: "fa-envelope-open" }, null, null);

  constructor(private appSvc: AppService,
    private domainSvc: DomainService,
    private navSvc: IceNavService,
    private router: Router,
    private loginSvc: LoginService,
    private changeDetectorRefs: ChangeDetectorRef) {
    this.appSvc.defaultMenus();
  }

  ngOnInit() {
    this.appSvc.refreshMenus();

    let panelTag = "MemberList";
    let panelKey = Iceutility.guid(false);
    let tables: IcemattableSettings[] = [
      new IcemattableSettings("MemberTable", [
        new iceColumnDefinition("Actions", "Actions", false, false),
        new iceColumnDefinition("prefix", "Title", false),
        new iceColumnDefinition("login_user_name", "", true, true),
        new iceColumnDefinition("first_name", "First name", false),
        new iceColumnDefinition("last_name", "Last name", false),
        new iceColumnDefinition("suffix", "Credentials", false),
      ],
      this.dataForMembers,
      [
        { name: "Send Message", value: MembersActionTypes.Send, iconclass: "fas fa-envelope-open" }],
      true)
    ];
    let groups: IcepanelgroupSettings[] = [
      new IcepanelgroupSettings(null, tables)
    ];

    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("MemberListSection", { class: ["yalla"], styles: { width: "100%" } }, groups, null, null)
    ];
    let fullName = "";
    let ursInfo = this.loginSvc.GetSessionUserInfo();
    if (ursInfo != null) fullName = ursInfo.Name;

    let panels: IcepanelSettings[] = [
      new IcepanelSettings(panelTag, panelKey, "Public Network Members of " + fullName, "", sections)];

    let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
    this.memberListSettings = new IcepanelcontainerSettings("MemberListContainer", panelrows);

    this.domainSvc.getNetworkOfMembers().subscribe(
      data => {
        if (data == null) return;

        let dat: MemberListObject[] = [];
        for (let i = 0; i < data.length; i++) {
          let usr: user = <user>data[i];
          if (usr == null) continue;

          dat.push(new MemberListObject(
            usr.login_user_name,
            usr.first_name,
            usr.last_name,
            usr.middle,
            usr.prefix,
            usr.suffix));
        }

        this.dataForMembers.data = dat;
      },
      error => {
        console.log(JSON.stringify(this.domainSvc.getLastErrors()));
      });
    this.changeDetectorRefs.detectChanges();
  }

  onInviteMember(event) {
    this.router.navigate([this.navSvc.buildRoute("invite", false)]);
  }

  public onNewMessage() {
    this.router.navigate([this.navSvc.buildRoute('newmessage', false)]);
  }

  onMatGridRowActionClick(event) {
    if (event.rowData == null) {
      // To do log error
      return;
    }
    this.domainSvc.broadcastData(event.rowData);
    this.router.navigate([this.navSvc.buildRoute('newmessage', false)]);
  }
}
